import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export type AgendaIconProps = SvgIconProps

export function AgendaIcon(props: AgendaIconProps) {
  const { htmlColor } = props
  return (
    <SvgIcon width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Calendar">
        <g>
          <g id="XMLID_00000106829482518642280380000009201565907049345704_">
            <g>
              <polygon
                style={{ fill: htmlColor || '#A7A9AC' }}
                points="129.481,35.076 177.131,35.076 177.131,60.926 175.151,60.926 23.391,60.926 22.871,60.926 22.871,35.076 60.191,35.076"
              />
              <rect x="137.211" y="79.086" style={{ fill: htmlColor || '#A7A9AC' }} width="15.68" height="15.68" />
              <rect x="137.031" y="141.416" style={{ fill: htmlColor || '#A7A9AC' }} width="15.68" height="15.68" />
              <rect x="136.931" y="110.596" style={{ fill: htmlColor || '#A7A9AC' }} width="15.68" height="15.68" />
              <rect x="105.921" y="141.416" style={{ fill: htmlColor || '#A7A9AC' }} width="15.68" height="15.68" />
              <rect x="105.871" y="79.086" style={{ fill: htmlColor || '#A7A9AC' }} width="15.68" height="15.68" />
              <rect x="105.821" y="110.596" style={{ fill: htmlColor || '#A7A9AC' }} width="15.68" height="15.68" />
              <rect x="74.821" y="141.416" style={{ fill: htmlColor || '#A7A9AC' }} width="15.68" height="15.68" />
              <rect x="74.721" y="110.596" style={{ fill: htmlColor || '#A7A9AC' }} width="15.67" height="15.68" />
              <rect x="74.721" y="79.086" style={{ fill: htmlColor || '#A7A9AC' }} width="15.67" height="15.68" />
              <rect x="43.561" y="110.596" style={{ fill: htmlColor || '#A7A9AC' }} width="15.68" height="15.68" />
              <rect x="43.561" y="79.086" style={{ fill: htmlColor || '#A7A9AC' }} width="15.68" height="15.68" />
              <polygon style={{ fill: htmlColor || '#A7A9AC' }} points="57.251,138.686 57.251,176.206 56.531,176.206 23.151,138.896 23.391,138.686" />
            </g>
            <g>
              <polygon
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                points="177.131,60.926 177.131,176.206 113.711,176.206 57.251,176.206 56.531,176.206 23.151,138.896 22.871,138.586 22.871,60.926 22.871,35.076 60.191,35.076 129.481,35.076 177.131,35.076"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="23.391"
                y1="60.926"
                x2="175.151"
                y2="60.926"
              />
              <polyline
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                points="60.191,46.816 60.191,35.076 60.191,23.686"
              />
              <polyline
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                points="129.481,46.816 129.481,35.076 129.481,23.686"
              />

              <rect
                x="137.211"
                y="79.086"
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                width="15.68"
                height="15.68"
              />

              <rect
                x="43.561"
                y="110.596"
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                width="15.68"
                height="15.68"
              />

              <rect
                x="74.721"
                y="110.596"
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                width="15.67"
                height="15.68"
              />

              <rect
                x="74.821"
                y="141.416"
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                width="15.68"
                height="15.68"
              />

              <rect
                x="105.821"
                y="110.596"
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                width="15.68"
                height="15.68"
              />

              <rect
                x="105.921"
                y="141.416"
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                width="15.68"
                height="15.68"
              />

              <rect
                x="136.931"
                y="110.596"
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                width="15.68"
                height="15.68"
              />

              <rect
                x="137.031"
                y="141.416"
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                width="15.68"
                height="15.68"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="45.971"
                y1="48.386"
                x2="74.811"
                y2="48.386"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="116.201"
                y1="48.386"
                x2="145.051"
                y2="48.386"
              />
              <polyline
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                points="23.391,138.686 57.251,138.686 57.251,176.206 57.251,176.306"
              />

              <rect
                x="43.561"
                y="79.086"
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                width="15.68"
                height="15.68"
              />

              <rect
                x="74.721"
                y="79.086"
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                width="15.67"
                height="15.68"
              />

              <rect
                x="105.871"
                y="79.086"
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                width="15.68"
                height="15.68"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Layer_1"></g>
    </SvgIcon>
  )
}

export default AgendaIcon
